import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNaN, isEmpty, map } from 'lodash';
import { Paper } from 'material-ui';

import { openIcon, closeIcon } from '../utils/icons';
import styles from './styles/Cards';

export const validateBankAccount = (values, all) => {
  const errors = {};

  if (values.BankAccountLedger) {
    if (!all.bankLedgers[values.BankAccountLedger]) {
      errors.BankAccountLedger = <FormattedMessage id="bank.errorLedger" />;
    }
  } else {
    errors.BankAccountLedger = ' ';
  }

  if (values.BankAccountNR) {
    if (isNaN(values.BankAccountNR)) {
      errors.BankAccountNR = <FormattedMessage id="bank.errorAccount" />;
    }
  } else {
    errors.BankAccountNR = ' ';
  }

  if (values.BankID) {
    if (!all.bankBranches[values.BankID]) {
      errors.BankID = <FormattedMessage id="bank.errorBranch" />;
    }
  } else {
    errors.BankID = ' ';
  }

  return errors;
};

export const validateTaxCard = (values, taxDiscount) => {
  const errors = {};

  const unused = parseInt(values.Unused, 10);

  if (unused < 0) {
    errors.Unused = <FormattedMessage id="taxCard.errorUnused.invalid" />;
  }

  const currentMonth = new Date().getMonth();
  const yearStart = new Date(new Date().getFullYear(), 0, 1);
  const lastUsed = new Date(values.DateLastUsed);
  const lastUsedMonth = lastUsed.getMonth();

  const multiplier = yearStart.getTime() > lastUsed.getTime() ? currentMonth : lastUsedMonth + 1;

  const maxDiscount = multiplier * taxDiscount;

  if (values.DateLastUsed === null) {
    errors.Unused = <FormattedMessage id="taxCard.errorUnused.noLast" />;
  } else if (unused > maxDiscount || unused < 0) {
    errors.Unused = <FormattedMessage id="taxCard.errorUnused.max" />;
  }

  return errors;
};

export const renderUnionRow = obj => (
  <div style={styles.row} key={obj.PayUnionID}>
    <div style={styles.col1}>
      <span style={styles.label}><FormattedMessage id="Union.number" /></span>
      <p>{obj.PayUnionID}</p>
    </div>
    <div>
      <span style={styles.label}><FormattedMessage id="Union" /></span>
      <p>{obj.PayUnionName}</p>
    </div>
  </div>
);

export const renderList = (obj, history, showHistory, setShowHistory, renderRow = renderUnionRow) => (
  <Paper>
    {renderRow(obj)}
    {!isEmpty(history) &&
    <button style={styles.buttonStyle} onClick={() => setShowHistory(!showHistory)}>
      {showHistory ? closeIcon : openIcon}
    </button>}
    {showHistory && map(history, u => renderRow(u))}
  </Paper>
);



// WEBPACK FOOTER //
// ./src/containers/pay/helpers.js